import { RenderChart } from '@components/ncFiles/components/paid';

export const getMax = ({
  item,
  barValueName,
  lineValueName,
  average,
  averagePaid,
  showAverage,
}: {
  item: RenderChart;
  barValueName: 'totalProductiveSecs' | 'averageActiveSecs' | 'averageChangeSecs' | 'averageSetupSecs';
  lineValueName: 'totalProductiveSecs' | 'averageActiveSecs' | 'averageChangeSecs' | 'averageSetupSecs';
  average: number;
  averagePaid: number;
  showAverage: boolean;
}) => {
  if (item) {
    const maxValueRaw = Math.max.apply(Math, [
      ...item.data?.data?.statisticsPerPeriod?.map((item) => Math.max(item[barValueName] || 0, item[lineValueName] || 0)),
      showAverage ? average : 0,
      showAverage ? averagePaid : 0,
    ]);

    let maxValue = maxValueRaw + (60 - (maxValueRaw % 60));
    if (maxValue > 3600) {
      maxValue = maxValueRaw + (3600 - (maxValueRaw % 3600));
    }
    return maxValue;
  }
};
